module.exports = __webpack_public_path__ + "img/cover-promotion-bg-mobile.6ffffd05.jpg";